<template>
  <div class="work-history-container">
    <!-- Hero Header Section -->
    <v-card class="hero-header mb-6" elevation="0">
      <div class="hero-content">
        <div class="hero-icon-wrapper">
          <v-icon size="48" color="white">mdi-briefcase-clock</v-icon>
        </div>
        <div class="hero-text">
          <h1 class="hero-title">ประวัติการรับราชการ</h1>
          <p class="hero-subtitle">บันทึกประวัติการปฏิบัติงานและหน่วยงานที่เคยสังกัด</p>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="add-btn" large depressed @click="personnel_work_historyAdd()">
          <v-icon left>mdi-plus</v-icon>
          เพิ่มประวัติ
        </v-btn>
      </div>
    </v-card>

    <!-- Statistics Cards -->
    <v-row class="stats-row mb-6">
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-1" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-file-document-multiple</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ personnel_work_historys.length }}</span>
            <span class="stat-label">รายการทั้งหมด</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-2" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-domain</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countByAffiliation('ovec') }}</span>
            <span class="stat-label">สังกัด สอศ.</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-3" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-office-building</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countByAffiliation('external') }}</span>
            <span class="stat-label">หน่วยงานภายนอก</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="stat-card stat-card-4" elevation="0">
          <div class="stat-icon">
            <v-icon color="white" size="28">mdi-swap-horizontal</v-icon>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ countAssisting() }}</span>
            <span class="stat-label">ช่วยราชการ</span>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Data Table Card -->
    <v-card class="main-table-card" elevation="0">
      <v-card-title class="table-header">
        <div class="header-left">
          <v-icon class="mr-3" color="#dc2626">mdi-history</v-icon>
          <span class="header-title">รายการประวัติการรับราชการ</span>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหารายการ..."
          single-line
          hide-details
          dense
          outlined
          class="search-field"
          style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="personnel_work_historys"
        :search="search"
        :items-per-page="10"
        class="modern-table"
        loading-text="กำลังโหลดข้อมูล..."
        no-data-text="ไม่พบข้อมูลประวัติการรับราชการ"
        no-results-text="ไม่พบผลลัพธ์ที่ค้นหา"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table-row">
            <td class="text-center">
              <v-avatar size="32" color="#dc2626" class="white--text font-weight-bold">
                {{ index + 1 }}
              </v-avatar>
            </td>
            <td class="text-center">
              <v-chip small color="#fef2f2" text-color="#dc2626" class="position-chip">
                <v-icon left small>mdi-card-account-details</v-icon>
                {{ item.id_position_old || '-' }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                small
                :color="(item.government_status === '1' || item.government_status === 1) ? '#a86400' : '#2e7d32'"
                dark
                class="status-chip"
              >
                <v-icon left small>
                  {{ item.government_status === '1' || item.government_status === 1 ? 'mdi-swap-horizontal' : 'mdi-check' }}
                </v-icon>
                {{ item.government_status === '1' || item.government_status === 1 ? 'ช่วยราชการ' : 'ปกติ' }}
              </v-chip>
            </td>
            <td>
              <div class="agency-cell">
                <v-icon small :color="item.pwh_type === '0' || item.pwh_type === 0 ? '#455a64' : '#d9777b'" class="mr-2">
                  {{ item.pwh_type === '0' || item.pwh_type === 0 ? 'mdi-school' : 'mdi-office-building' }}
                </v-icon>
                <div class="agency-info">
                  <span class="agency-name">
                    {{ item.pwh_type === '0' || item.pwh_type === 0 ? item.college_name_work : item.pwh_affiliation }}
                  </span>
                  <v-chip x-small :color="item.pwh_type === '0' || item.pwh_type === 0 ? '#e4e4e7' : '#fbecec'" 
                    :text-color="item.pwh_type === '0' || item.pwh_type === 0 ? '#455a64' : '#b3151b'" class="mt-1">
                    {{ item.pwh_type === '0' || item.pwh_type === 0 ? 'สอศ.' : 'ภายนอก' }}
                  </v-chip>
                </div>
              </div>
            </td>
            <td>
              <div class="position-cell">
                <v-icon small color="#a86400" class="mr-1">mdi-account-tie</v-icon>
                {{ item.position_s }}
              </div>
            </td>
            <td class="text-center">
              <div class="date-range">
                <v-chip small color="#e8f5e9" text-color="#2e7d32" class="date-chip mb-1">
                  <v-icon left x-small>mdi-calendar-start</v-icon>
                  {{ item.date_begin | moment("add", "543 years") | moment("D MMM YY") }}
                </v-chip>
                <v-icon x-small color="#9ca3af" class="mx-1">mdi-arrow-right</v-icon>
                <v-chip small color="#fff4dc" text-color="#a86400" class="date-chip">
                  <v-icon left x-small>mdi-calendar-end</v-icon>
                  {{ item.date_end | moment("add", "543 years") | moment("D MMM YY") }}
                </v-chip>
              </div>
            </td>
            <td>
              <div class="duty-cell" v-if="item.special_duty">
                <v-icon small color="#6b7280" class="mr-1">mdi-clipboard-list</v-icon>
                <span class="duty-text">{{ item.special_duty }}</span>
              </div>
              <span v-else class="text--disabled">-</span>
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn edit-btn mr-1"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="personnel_work_historyEdit(item.id_rh)"
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>แก้ไข</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    class="action-btn delete-btn"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="personnel_work_historyDelete(item.id_rh)"
                  >
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>ลบ</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Add Work History Dialog -->
    <v-dialog
      v-model="addpersonnel_work_historydialog"
      persistent
      max-width="800px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header add-header">
          <v-icon class="mr-3" color="white" size="28">mdi-plus-circle-outline</v-icon>
          <span>เพิ่มประวัติการรับราชการ</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="addpersonnel_work_historydialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-form ref="addpersonnel_work_historyform" lazy-validation>
            <!-- Section: ประเภทหน่วยงาน -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#dc2626" class="mr-2">mdi-domain</v-icon>
                ประเภทหน่วยงาน
              </div>
              <v-radio-group
                v-model="addpersonnel_work_history.pwh_type"
                row
                :rules="[v => v !== undefined && v !== null && v !== '' || 'กรุณาเลือกประเภทหน่วยงาน']"
                class="mt-0"
              >
                <v-radio value="0" class="type-radio">
                  <template v-slot:label>
                    <div class="radio-label">
                      <v-icon color="#455a64" class="mr-2">mdi-school</v-icon>
                      <span class="radio-text success--text font-weight-medium">สังกัด สอศ.</span>
                    </div>
                  </template>
                </v-radio>
                <v-radio value="1" class="type-radio ml-6">
                  <template v-slot:label>
                    <div class="radio-label">
                      <v-icon color="#d9777b" class="mr-2">mdi-office-building</v-icon>
                      <span class="radio-text primary--text font-weight-medium">หน่วยงานภายนอก</span>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- Section: ข้อมูลตำแหน่ง -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#a86400" class="mr-2">mdi-badge-account</v-icon>
                ข้อมูลตำแหน่ง
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_work_history.id_position"
                    label="เลขที่ตำแหน่ง"
                    placeholder="เช่น 12345"
                    :rules="[v => !!v || 'กรุณาระบุเลขที่ตำแหน่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-card-account-details"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="addpersonnel_work_history.government_status"
                    :items="service_status"
                    item-text="text"
                    item-value="value"
                    label="สถานะช่วยราชการ"
                    :rules="[v => v !== undefined && v !== null && v !== '' || 'กรุณาเลือกสถานะ']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-swap-horizontal"
                    class="modern-input"
                  >
                    <template v-slot:item="{ item }">
                      <v-icon :color="(item.value === '1' || item.value === 1) ? '#a86400' : '#2e7d32'" class="mr-2" small>
                        {{ (item.value === '1' || item.value === 1) ? 'mdi-swap-horizontal' : 'mdi-check' }}
                      </v-icon>
                      {{ item.text }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6" v-if="addpersonnel_work_history.pwh_type === '0'">
                  <v-autocomplete
                    v-model="addpersonnel_work_history.college_code"
                    :items="users"
                    item-value="user_code"
                    item-text="agency"
                    label="สถานศึกษา สอศ."
                    :rules="[v => !!v || 'กรุณาเลือกสถานศึกษา']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-school"
                    class="modern-input"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" v-if="addpersonnel_work_history.pwh_type === '1' || addpersonnel_work_history.pwh_type === 1">
                  <v-text-field
                    v-model="addpersonnel_work_history.pwh_affiliation"
                    label="ชื่อหน่วยงาน/สังกัด"
                    placeholder="เช่น กรมบัญชีกลาง, สพฐ."
                    :rules="[v => !!v || 'กรุณาระบุหน่วยงาน']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-office-building"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_work_history.position_s"
                    label="ตำแหน่ง"
                    placeholder="เช่น ครู, ครูชำนาญการ"
                    :rules="[v => !!v || 'กรุณาระบุตำแหน่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-tie"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section: ระยะเวลา -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#2e7d32" class="mr-2">mdi-calendar-range</v-icon>
                ระยะเวลาการปฏิบัติงาน
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_work_history.date_begin"
                    label="วันที่เริ่มต้น"
                    type="date"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-start"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addpersonnel_work_history.date_end"
                    label="วันที่สิ้นสุด"
                    type="date"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-end"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section: หน้าที่อื่น -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#d9777b" class="mr-2">mdi-clipboard-list-outline</v-icon>
                หน้าที่เพิ่มเติม
              </div>
              <v-text-field
                v-model="addpersonnel_work_history.special_duty"
                label="หน้าที่อื่น / งานพิเศษ"
                placeholder="เช่น หัวหน้าแผนกวิชา, ครูที่ปรึกษา"
                outlined
                dense
                prepend-inner-icon="mdi-clipboard-text"
                class="modern-input"
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="addpersonnel_work_historydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#dc2626"
            dark
            @click="addpersonnel_work_historySubmit()"
            class="save-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Work History Dialog -->
    <v-dialog
      v-model="editpersonnel_work_historydialog"
      persistent
      max-width="800px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header edit-header">
          <v-icon class="mr-3" color="white" size="28">mdi-pencil-outline</v-icon>
          <span>แก้ไขประวัติการรับราชการ</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="editpersonnel_work_historydialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-form ref="editpersonnel_work_historyform" lazy-validation>
            <!-- Section: ข้อมูลตำแหน่ง -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#a86400" class="mr-2">mdi-badge-account</v-icon>
                ข้อมูลตำแหน่ง
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editpersonnel_work_history.id_position"
                    label="เลขที่ตำแหน่ง"
                    :rules="[v => !!v || 'กรุณาระบุเลขที่ตำแหน่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-card-account-details"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="editpersonnel_work_history.government_status"
                    :items="service_status"
                    item-text="text"
                    item-value="value"
                    label="สถานะช่วยราชการ"
                    :rules="[v => v !== undefined && v !== null && v !== '' || 'กรุณาเลือกสถานะ']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-swap-horizontal"
                    class="modern-input"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="editpersonnel_work_history.college_code"
                    :items="users"
                    item-value="user_code"
                    item-text="agency"
                    label="สถานศึกษา"
                    outlined
                    dense
                    prepend-inner-icon="mdi-school"
                    class="modern-input"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editpersonnel_work_history.position_s"
                    label="ตำแหน่ง"
                    :rules="[v => !!v || 'กรุณาระบุตำแหน่ง']"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-tie"
                    class="modern-input"
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>

            <!-- Section: ระยะเวลา -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#2e7d32" class="mr-2">mdi-calendar-range</v-icon>
                ระยะเวลาการปฏิบัติงาน
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editpersonnel_work_history.date_begin"
                        label="วันที่เริ่มต้น"
                        prepend-inner-icon="mdi-calendar-start"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editpersonnel_work_history.date_begin"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#a86400"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="menu = false">ยกเลิก</v-btn>
                      <v-btn text color="#a86400" @click="$refs.menu.save(date)">ตกลง</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="editpersonnel_work_history.date_end"
                        label="วันที่สิ้นสุด"
                        prepend-inner-icon="mdi-calendar-end"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        class="modern-input"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editpersonnel_work_history.date_end"
                      no-title
                      scrollable
                      locale="th-TH"
                      color="#a86400"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="grey" @click="menu2 = false">ยกเลิก</v-btn>
                      <v-btn text color="#a86400" @click="$refs.menu2.save(date)">ตกลง</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>

            <!-- Section: หน้าที่อื่น -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="#d9777b" class="mr-2">mdi-clipboard-list-outline</v-icon>
                หน้าที่เพิ่มเติม
              </div>
              <v-text-field
                v-model="editpersonnel_work_history.special_duty"
                label="หน้าที่อื่น / งานพิเศษ"
                outlined
                dense
                prepend-inner-icon="mdi-clipboard-text"
                class="modern-input"
              ></v-text-field>
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="editpersonnel_work_historydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#a86400"
            dark
            @click="editpersonnel_work_historySubmit()"
            class="save-btn"
          >
            <v-icon left>mdi-content-save-outline</v-icon>
            บันทึกการแก้ไข
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation Dialog -->
    <v-dialog
      v-model="deletepersonnel_work_historydialog"
      persistent
      max-width="500px"
      content-class="modern-dialog"
    >
      <v-card class="dialog-card delete-dialog">
        <v-card-title class="dialog-header delete-header">
          <v-icon class="mr-3" color="white" size="28">mdi-delete-alert-outline</v-icon>
          <span>ยืนยันการลบข้อมูล</span>
        </v-card-title>

        <v-card-text class="delete-content text-center">
          <v-form ref="deletepersonnel_work_historyform" lazy-validation>
            <div class="delete-icon-wrapper">
              <v-icon size="72" color="#dc2626">mdi-alert-circle-outline</v-icon>
            </div>
            <div class="delete-message">คุณต้องการลบรายการนี้หรือไม่?</div>

            <v-card class="delete-info-card mt-4" outlined>
              <v-card-text class="pa-4">
                <div class="delete-info-item mb-2">
                  <v-icon small color="#dc2626" class="mr-2">mdi-card-account-details</v-icon>
                  <span class="info-label">เลขที่ตำแหน่ง:</span>
                  <span class="info-text ml-2">{{ editpersonnel_work_history.id_position_old }}</span>
                </div>
                <div class="delete-info-item mb-2">
                  <v-icon small color="#455a64" class="mr-2">mdi-school</v-icon>
                  <span class="info-label">หน่วยงาน:</span>
                  <span class="info-text ml-2">{{ editpersonnel_work_history.college_name_work || editpersonnel_work_history.pwh_affiliation }}</span>
                </div>
                <div class="delete-info-item">
                  <v-icon small color="#a86400" class="mr-2">mdi-account-tie</v-icon>
                  <span class="info-label">ตำแหน่ง:</span>
                  <span class="info-text ml-2">{{ editpersonnel_work_history.position_s }}</span>
                </div>
              </v-card-text>
            </v-card>

            <div class="delete-warning mt-4">
              <v-icon small color="#a86400" class="mr-1">mdi-alert</v-icon>
              การดำเนินการนี้ไม่สามารถย้อนกลับได้
            </div>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn text large @click="deletepersonnel_work_historydialog = false" class="cancel-btn">
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            depressed
            color="#dc2626"
            dark
            @click="deletepersonnel_work_historyubmit()"
            class="delete-confirm-btn"
          >
            <v-icon left>mdi-delete-outline</v-icon>
            ลบข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      class="modern-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-3" color="white">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'PersonnelWorkHistory',

  data() {
    return {
      ApiKey: 'HRvec2021',
      loading: true,
      search: '',
      addpersonnel_work_historydialog: false,
      editpersonnel_work_historydialog: false,
      deletepersonnel_work_historydialog: false,
      snackbar: {
        show: false,
        color: '',
        timeout: 4000,
        icon: '',
        text: ''
      },
      headers: [
        { text: '#', align: 'center', value: 'index', width: '60px', sortable: false },
        { text: 'เลขที่ตำแหน่ง', align: 'center', value: 'id_position_old', width: '130px' },
        { text: 'สถานะ', align: 'center', value: 'government_status', width: '120px' },
        { text: 'หน่วยงาน/สังกัด', align: 'left', value: 'college_name_work' },
        { text: 'ตำแหน่ง', align: 'left', value: 'position_s', width: '150px' },
        { text: 'ช่วงเวลา', align: 'center', value: 'date_begin', width: '200px' },
        { text: 'หน้าที่อื่น', align: 'left', value: 'special_duty', width: '180px' },
        { text: 'จัดการ', align: 'center', value: 'actions', sortable: false, width: '100px' }
      ],
      personnel_work_historys: [],
      addpersonnel_work_history: {},
      editpersonnel_work_history: {},
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      service_status: [
        { text: 'ไม่ได้ช่วยราชการ', value: '0' },
        { text: 'ช่วยราชการ', value: '1' }
      ],
      users: []
    }
  },

  async mounted() {
    // Load colleges/agencies
    let result = await this.$http.post('user.php', {
      ApiKey: this.ApiKey,
      show_user: 'ok'
    })
    this.users = result.data

    await this.personnel_work_historysQueryAll()
  },

  methods: {
    countByAffiliation(type) {
      if (type === 'ovec') {
        return this.personnel_work_historys.filter(item => item.pwh_type === '0' || item.pwh_type === 0).length
      } else {
        return this.personnel_work_historys.filter(item => item.pwh_type === '1' || item.pwh_type === 1).length
      }
    },

    countAssisting() {
      return this.personnel_work_historys.filter(item => item.government_status === '1' || item.government_status === 1).length
    },

    async personnel_work_historysQueryAll() {
      this.loading = true
      let userSession = JSON.parse(localStorage.getItem('user')) || 0
      let result = await this.$http
        .post('personnel_work_history.php', {
          ApiKey: this.ApiKey,
          id_card: userSession.id_card
        })
        .finally(() => (this.loading = false))
      this.personnel_work_historys = result.data || []
    },

    personnel_work_historyAdd() {
      this.addpersonnel_work_history = {}
      this.addpersonnel_work_historydialog = true
    },

    async addpersonnel_work_historySubmit() {
      if (this.$refs.addpersonnel_work_historyform.validate()) {
        let userSession = JSON.parse(localStorage.getItem('user')) || 0
        this.addpersonnel_work_history.ApiKey = this.ApiKey
        this.addpersonnel_work_history.id_card = userSession.id_card

        let result = await this.$http.post(
          'personnel_work_history.insert.php',
          this.addpersonnel_work_history
        )

        if (result.data.status === true) {
          Swal.fire({
            icon: 'success',
            title: 'บันทึกสำเร็จ',
            text: 'เพิ่มประวัติการรับราชการเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.personnel_work_historysQueryAll()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้',
            showConfirmButton: true
          })
        }
        this.addpersonnel_work_historydialog = false
      }
    },

    async personnel_work_historyEdit(id_rh) {
      let result = await this.$http.post('personnel_work_history.php', {
        ApiKey: this.ApiKey,
        id_rh: id_rh
      })
      this.editpersonnel_work_history = result.data
      this.editpersonnel_work_historydialog = true
    },

    async editpersonnel_work_historySubmit() {
      if (this.$refs.editpersonnel_work_historyform.validate()) {
        this.editpersonnel_work_history.ApiKey = this.ApiKey

        let result = await this.$http.post(
          'personnel_work_history.update.php',
          this.editpersonnel_work_history
        )

        if (result.data.status === true) {
          Swal.fire({
            icon: 'success',
            title: 'แก้ไขสำเร็จ',
            text: 'อัปเดตประวัติการรับราชการเรียบร้อยแล้ว',
            showConfirmButton: false,
            timer: 1500
          })
          this.personnel_work_historysQueryAll()
        } else {
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถแก้ไขข้อมูลได้',
            showConfirmButton: true
          })
        }
        this.editpersonnel_work_historydialog = false
      }
    },

    async personnel_work_historyDelete(id_rh) {
      let result = await this.$http.post('personnel_work_history.php', {
        ApiKey: this.ApiKey,
        id_rh: id_rh
      })
      this.editpersonnel_work_history = result.data
      this.deletepersonnel_work_historydialog = true
    },

    async deletepersonnel_work_historyubmit() {
      this.editpersonnel_work_history.ApiKey = this.ApiKey

      let result = await this.$http.post(
        'personnel_work_history.delete.php',
        this.editpersonnel_work_history
      )

      if (result.data.status === true) {
        Swal.fire({
          icon: 'success',
          title: 'ลบสำเร็จ',
          text: 'ลบประวัติการรับราชการเรียบร้อยแล้ว',
          showConfirmButton: false,
          timer: 1500
        })
        this.personnel_work_historysQueryAll()
      } else {
        Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถลบข้อมูลได้',
          showConfirmButton: true
        })
      }
      this.deletepersonnel_work_historydialog = false
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap');

.work-history-container {
  font-family: 'Prompt', sans-serif;
  padding: 24px;
  background: linear-gradient(180deg, #fafafa 0%, #f5f5f5 100%);
  min-height: 100vh;
}

/* Hero Header */
.hero-header {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 50%, #991b1b 100%);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 10px 40px rgba(220, 38, 38, 0.3);
}

.hero-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.06'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.hero-content {
  display: flex;
  align-items: center;
  padding: 32px;
  position: relative;
  z-index: 1;
  flex-wrap: wrap;
  gap: 16px;
}

.hero-icon-wrapper {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.hero-text {
  color: white;
}

.hero-title {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.hero-subtitle {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

.add-btn {
  background: white !important;
  color: #dc2626 !important;
  font-weight: 500;
  border-radius: 12px;
  padding: 0 28px !important;
  text-transform: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Statistics Cards */
.stats-row {
  margin-top: -16px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card-1 .stat-icon { background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); }
.stat-card-2 .stat-icon { background: linear-gradient(135deg, #455a64 0%, #455a64 100%); }
.stat-card-3 .stat-icon { background: linear-gradient(135deg, #d9777b 0%, #b3151b 100%); }
.stat-card-4 .stat-icon { background: linear-gradient(135deg, #a86400 0%, #a86400 100%); }

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #263238;
  line-height: 1;
}

.stat-label {
  font-size: 13px;
  color: #6b7280;
  margin-top: 4px;
}

/* Main Table Card */
.main-table-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.table-header {
  padding: 20px 24px;
  background: #fafafa;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #263238;
}

.search-field {
  background: white;
}

.search-field >>> .v-input__slot {
  border-radius: 12px !important;
}

/* Data Table */
.modern-table {
  font-family: 'Prompt', sans-serif;
}

.modern-table >>> thead th {
  background: #fef2f2 !important;
  color: #991b1b !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid #fecaca !important;
  padding: 14px 8px !important;
}

.table-row {
  transition: all 0.2s ease;
}

.table-row:hover {
  background: #fffbfb !important;
}

.table-row td {
  padding: 14px 8px !important;
  border-bottom: 1px solid #f3f4f6 !important;
  font-size: 13px;
  color: #374151;
}

/* Cell Styles */
.agency-cell {
  display: flex;
  align-items: flex-start;
}

.agency-info {
  display: flex;
  flex-direction: column;
}

.agency-name {
  font-size: 13px;
  color: #263238;
  line-height: 1.4;
}

.position-cell {
  display: flex;
  align-items: center;
  font-size: 13px;
}

.date-range {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.duty-cell {
  display: flex;
  align-items: flex-start;
}

.duty-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.4;
}

/* Action Buttons */
.action-btn {
  width: 32px !important;
  height: 32px !important;
  transition: all 0.2s ease;
}

.edit-btn {
  background: #fff4dc !important;
  color: #a86400 !important;
}

.edit-btn:hover {
  background: #fff4dc !important;
  transform: scale(1.1);
}

.delete-btn {
  background: #fef2f2 !important;
  color: #dc2626 !important;
}

.delete-btn:hover {
  background: #fecaca !important;
  transform: scale(1.1);
}

/* Dialog Styles */
.modern-dialog {
  border-radius: 20px !important;
}

.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  padding: 20px 24px;
  font-size: 18px;
  font-weight: 600;
}

.add-header {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
}

.edit-header {
  background: linear-gradient(135deg, #a86400 0%, #a86400 100%);
  color: white;
}

.delete-header {
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  color: white;
}

.dialog-content {
  padding: 24px !important;
  max-height: 65vh;
  overflow-y: auto;
}

.form-section {
  background: #fafafa;
  border-radius: 14px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #f3f4f6;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #263238;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.modern-input >>> .v-input__slot {
  background: white !important;
  border-radius: 10px !important;
}

.radio-label {
  display: flex;
  align-items: center;
}

.radio-text {
  font-size: 14px;
}

.dialog-actions {
  padding: 16px 24px;
  background: #fafafa;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
  text-transform: none;
}

.save-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
  padding: 0 24px !important;
}

/* Delete Dialog */
.delete-content {
  padding: 32px 24px !important;
}

.delete-icon-wrapper {
  margin-bottom: 16px;
}

.delete-message {
  font-size: 18px;
  font-weight: 500;
  color: #263238;
}

.delete-info-card {
  background: #fafafa;
  border-radius: 12px !important;
  border-color: #e5e7eb !important;
  text-align: left;
}

.delete-info-item {
  display: flex;
  align-items: center;
}

.info-label {
  font-size: 12px;
  color: #6b7280;
}

.info-text {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.delete-warning {
  font-size: 13px;
  color: #a86400;
}

.delete-confirm-btn {
  border-radius: 10px;
  font-weight: 500;
  text-transform: none;
}

/* Responsive */
@media (max-width: 960px) {
  .hero-content {
    padding: 24px;
  }

  .hero-icon-wrapper {
    width: 64px;
    height: 64px;
  }

  .hero-title {
    font-size: 20px;
  }

  .add-btn {
    width: 100%;
  }

  .date-range {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .work-history-container {
    padding: 16px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-number {
    font-size: 24px;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.stat-card:nth-child(1) { animation-delay: 0.1s; }
.stat-card:nth-child(2) { animation-delay: 0.2s; }
.stat-card:nth-child(3) { animation-delay: 0.3s; }
.stat-card:nth-child(4) { animation-delay: 0.4s; }

/* Custom scrollbar */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}
</style>